<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Ranking de Usuários
                <a
                  data-toggle="collapse"
                  href="#collapseFilter"
                  aria-expanded="false"
                  aria-controls="collapseFilter"
                  class="btn-filter"
                >
                  Filtros
                  <i class="fas fa-filter"></i>
                </a>
              </div>
            </div>
            <div class="card-body">
              <div class="collapse" id="collapseFilter">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartSpot">Filial</label>
                      <v-select
                        :options="branches"
                        label="description"
                        :clearable="false"
                        :reduce="branches => branches.id"
                        class="style-chooser"
                        v-model="filter.branch_id"
                      >
                        <div slot="no-options">Carregando...</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartDateStart">Data Início</label>
                      <CtkDateTimePicker
                        v-model="filter.retreat_date"
                        color="orange"
                        locale="pt-br"
                        no-label
                        only-date
                        button-now-translation="Hoje"
                        class="datetimepicker"
                        label="Selecione a data de retirada"
                        format="YYYY-MM-DD hh:mm:ss"
                        id="retreat_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartDateEnd">Data Final</label>
                      <CtkDateTimePicker
                        v-model="filter.devolution_date"
                        color="orange"
                        locale="pt-br"
                        no-label
                        only-date
                        button-now-translation="Hoje"
                        class="datetimepicker"
                        label="Selecione a data de devolução"
                        format="YYYY-MM-DD hh:mm:ss"
                        id="devolution_date"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button type="button" class="btn btn-add" @click="filterDashboard()">Filtrar</button>
                  </div>
                </div>
              </div>
              <div id="app">
                <GChart
                  v-if="renderComponent"
                  type="ColumnChart"
                  :data="chartDatas"
                  :options="chartOptions"
                  style="width: 90%"
                />
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col" width="5%">N.</th>
                      <th scope="col" width="40%">Usuário</th>
                      <th scope="col" width="20%">Quantidade de Reservas</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in datas" :key="data.month">
                      <td>{{ index+1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>{{ data.total }}</td>
                    </tr>
                    <tr v-if="datas.length <= 0">
                      <td
                        colspan="3"
                        align="center"
                      >Não foi possível gerar os gráficos, pois não existem viagens no período atual, por favor, filtre outra data.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import vSelect from "vue-select";
import CtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  name: "App",
   data() {
    return {
      chartOptions: {
        chart: {
          title: "Relação Reservados X Retirados",
          subtitle:
            "Representação de Reservados X Retirados nos últimos 12 meses"
        },
        colors: ["#f49e00", "#1b9e77"],
        Axis: { format: "decimal" },
        height: 350
      },
      chartDatas: [],
      datas: [],
      branches: [
        {
          id: null,
          description: "TODAS AS FILIAIS"
        }
      ],
      branchesAll: {
        id: null,
        description: "TODAS AS FILIAIS"
      },
      filter: {
        retreat_date: "",
        devolution_date: "",
        branch_id: null
      },
      renderComponent: false
    };
  },
  methods: {
    getDashboards: function(id) {
      const self = this;
      const api = self.$store.state.api + "rankingUsers";

      self.$http
        .get(api)
        .then(response => {
          self.datas = response.data.table;

          self.chartDatas[0] = ["Usuário", "Quantidade"];

          for (var i = 0; i < self.datas.length; i++) {
            var j = i + 1;
            self.chartDatas[j] = [self.datas[i].name, self.datas[i].total];
          }

          console.log(self.datas.length);
          if (self.datas.length > 0) {
            this.renderComponent = true;
          }
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    filterDashboard: function() {
      this.datas = "";
      this.renderComponent = false;

      this.chartDatas = ["Usuário", "Quantidade"];

      const self = this;
      const api = self.$store.state.api + "rankingUsers";

      var data_1 = new Date(this.filter.retreat_date);
      var data_2 = new Date(this.filter.devolution_date);

      if (
        this.filter.branch_id == "" ||
        this.filter.retreat_date == "" ||
        this.filter.devolution_date == "" ||
        this.filter.retreat_date == null ||
        this.filter.devolution_date == null
      ) {
        swal("Erro", "Os dados do formulário não podem ser vazios", "error");
      } else {
        if (data_1 > data_2) {
          swal(
            "Erro",
            "Data inicial não pode ser maior que data final",
            "error"
          );
        } else {
          const self = this;

          let fd = new FormData();

          fd.append("_method", "GET");
          fd.append("branch_id", self.filter.branch_id);
          fd.append("retreat_date", self.filter.retreat_date);
          fd.append("devolution_date", self.filter.devolution_date);

          self.$http
            .post(api, fd)
            .then(response => {
              self.datas = response.data.table;

              self.chartDatas[0] = ["Usuário", "Quantidade"];

              for (var a = 0; a < self.datas.length; a++) {
                var b = a + 1;
                self.chartDatas[b] = [self.datas[a].name, self.datas[a].total];
              }

              if (self.datas.length > 0) {
                this.renderComponent = true;
              }
            })
            .catch(error => {
              self.$message(null, error.response.data, "error");
            });
        }
      }
    },

    getBranches: function(id) {
      const self = this;
      const api = self.$store.state.api + "branches/";

      self.$http
        .get(api)
        .then(response => {
          self.branches = response.data.data;
          this.branches.unshift(this.branchesAll);
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    }
  },
  mounted: function() {
    const self = this;
    self.getDashboards();
    self.getBranches();
  },

  components: {
    GChart,
    vSelect,
    CtkDateTimePicker
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Indicators/ranking_users.vue